// deprecated in favor of useGiveWidget.js
// (requires a switch from createReactClass to hooks)

/* global isMobileView isVIPDonor dcAnalytics readCookie createCookie */

export const GiveWidgetMixin = {
    getInitialState: function () {
        return {
            showGiveWidget: false,
        };
    },

    componentDidMount: function () {
        $(window).on('toggleGiveWidget', this.toggleGiveWidget);
        var cookieShowGiveWidget = readCookie('showGiveWidget');
        var show = !isMobileView() &&
            (
                (isVIPDonor() && (cookieShowGiveWidget == null || cookieShowGiveWidget == 'true')) ||
                    (!isVIPDonor() && !!cookieShowGiveWidget && cookieShowGiveWidget == 'true')
            );
        this.setState({
            showGiveWidget: show,
        });
        if (typeof dcAnalytics !== 'undefined') {
            dcAnalytics.track('Initial Give Widget Toggle', {
                cookieShowGiveWidget: (cookieShowGiveWidget == null ? 'not set' : cookieShowGiveWidget),
                show: show.toString(),
            });
        }
    },

    toggleGiveWidget: function () {
        var showWidget = !this.state.showGiveWidget;
        this.setState({
            showGiveWidget: showWidget,
        });

        createCookie('showGiveWidget', showWidget.toString());
    },
};
